/* eslint-disable no-underscore-dangle */
import PhotoEntity from "./models/photo-entity"
import PhotosService from "./repository/photos-service"
import PhotosStorage from "./repository/photos-storage"
import PhotosRepository from "./repository/photos-repository"
import CommentVotesRepository from "./repository/comment-votes-repository"
import CommentVotesService from "./repository/comment-votes-service"
import UserRepository from "./repository/user-repository"
import PhotosBloc from "./bloc/photos-bloc"
import View from "./view/view"

/** @typedef {import('./bloc/photos-state').default} PhotosState */

export default class GalleryPhotoComponent {
  /**
   * Creates an instance of GalleryPhotoComponent.
   * @param {Object} settings
   * @param {string} settings.token
   * @param {string} settings.location
   * @param {boolean} settings.loggedIn
   * @param {boolean} settings.memberMode
   * @param {HTMLElement} settings.htmlElement
   * @memberof GalleryPhotoComponent
   */
  constructor({ htmlElement, token, location, loggedIn, memberMode }) {
    const currentPhoto = PhotoEntity.fromHtmlElement(htmlElement)

    this._commentVotesRepository = new CommentVotesRepository({
      service: new CommentVotesService(token),
    })
    this._photosRepository = new PhotosRepository({
      service: new PhotosService(token, location),
      storage: new PhotosStorage(currentPhoto),
    })
    this._userRepository = new UserRepository({ memberMode, loggedIn })

    this._bloc = new PhotosBloc({
      currentPhoto,
      build: this.build.bind(this),
      userRepository: this._userRepository,
      photosRepository: this._photosRepository,
      commentVotesRepository: this._commentVotesRepository,
    })

    this._view = new View(this._bloc, htmlElement)
  }

  get state() {
    return this._bloc.state
  }

  /**
   * @param {Number} photoId
   * @memberof GalleryPhotoComponent
   */
  async preload(photoId) {
    await this._photosRepository.preload(photoId)
    this._bloc.photosPreloaded()
  }

  /**
   * @param {PhotosState} state
   * @memberof GalleryPhotoComponent
   */
  build(state) {
    this._view.update(state)
  }
}
